var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutscanBags(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1562_8933)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1562_8933)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1562_8933)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 0H9.2C4.11898 0 0 4.11898 0 9.2V70C0 75.081 4.11898 79.2 9.2 79.2H70C75.081 79.2 79.2 75.081 79.2 70V9.2C79.2 4.11898 75.081 0 70 0Z",
    fill: "#F8FBFF",
    stroke: "#F0F2F5",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6781 30.2344H13V60.9997H43.6781V30.2344Z",
    fill: "#EAA123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2197 60.9995V55.1995H42.1371L40.7162 52.6035L39.2949 55.1995H40.2121V60.9995H41.2197Z",
    fill: "#FFD4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1582 60.9995V55.1995H38.075L36.6544 52.6035L35.2334 55.1995H36.1505V60.9995H37.1582Z",
    fill: "#FFD4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.169 30.2344H25.5093V60.9997H31.169V30.2344Z",
    fill: "#FFC766"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0764 24.3809H46.8559V40.1761C45.5562 40.641 44.1567 40.8953 42.6971 40.8953C35.8798 40.8953 30.3535 35.3684 30.3535 28.5505C30.3538 27.0876 30.609 25.6842 31.0764 24.3809Z",
    fill: "#EAA123"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6603 25.8066V31.2971C30.4597 30.414 30.3535 29.4957 30.3535 28.5514C30.3538 27.6086 30.4597 26.6897 30.6603 25.8066Z",
    fill: "#FFC766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2633 34.8444L48.5459 37.4219L57.8228 43.6031L59.5401 41.0257L50.2633 34.8444Z",
    fill: "#3DB0C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7724 47.3425C62.9104 48.1034 64.4499 47.7939 65.208 46.6559C65.9671 45.5185 65.6593 43.9808 64.519 43.2221L55.7597 37.3826C54.6221 36.6245 53.0835 36.9322 52.325 38.0686C51.566 39.2069 51.874 40.7458 53.0117 41.5046L61.7724 47.3425Z",
    fill: "#2B4361"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9028 19C43.0891 18.9985 45.2996 19.6209 47.2548 20.9233C52.5202 24.4328 53.9442 31.5448 50.4346 36.8105C48.2296 40.1185 44.6012 41.9087 40.9028 41.9123V39.7758C43.9118 39.7725 46.8641 38.3159 48.6583 35.6242C51.5123 31.3436 50.3538 25.5566 46.0695 22.7014C44.4793 21.6416 42.6809 21.1351 40.9028 21.1363V19ZM31.3715 24.1013C33.5757 20.7926 37.2035 19.0036 40.9028 19L40.9031 21.1366C37.894 21.139 34.9411 22.5955 33.1473 25.2863C30.2945 29.5675 31.4515 35.3572 35.733 38.2124C37.3247 39.2723 39.1237 39.7785 40.9031 39.7761V41.9126C38.7161 41.9151 36.5039 41.2927 34.5477 39.9882C29.2838 36.4804 27.8614 29.3669 31.3715 24.1013Z",
    fill: "#2B4361"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7333 39.8919C53.587 39.8919 54.283 39.1956 54.283 38.3427C54.283 37.4887 53.5867 36.793 52.7333 36.793C51.8801 36.793 51.1841 37.4887 51.1841 38.3427C51.1841 39.1959 51.8801 39.8919 52.7333 39.8919Z",
    fill: "#3DB0C9"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1562_8933"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1562_8933"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1562_8933"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutscanBags);
export default __webpack_public_path__ + "static/media/outscanBags.18b40ef2cf213a7dd396222fb37bb73f.svg";
export { ForwardRef as ReactComponent };